import { Link } from "react-router-dom";
import { CreditCard, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function MembershipStatus() {
  const { user } = useAuth();
  const active = user?.membership_status === "active";

  return (
    <div data-testid="dashboard-membership-page">
      <h1 className="font-anton uppercase tracking-tighter text-cream text-3xl sm:text-4xl mb-8">Membership</h1>
      <div className="bg-surface border border-line p-8 max-w-lg">
        <CreditCard className="h-8 w-8 text-gold mb-4" />
        <p className="text-smoke text-xs uppercase tracking-widest">Current Plan</p>
        <p className="text-cream text-2xl font-anton uppercase mt-1">
          {active ? user.membership_plan.replace(/_/g, " ") : "No Active Membership"}
        </p>
        <span className={`inline-block mt-4 text-xs uppercase tracking-widest px-3 py-1 border ${active ? "border-gold text-gold" : "border-line text-smoke"}`}>
          {active ? "Active" : "Inactive"}
        </span>
        <Button asChild className="rounded-none bg-gold text-void hover:bg-gold-hover font-bold uppercase tracking-wider mt-8 w-full" data-testid="membership-page-manage-button">
          <Link to="/membership">
            {active ? "Change Plan" : "Choose a Plan"} <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
